<template>
  <div class="toolbar-box">
    <div v-for="t in config"
         :key="t.key"
         v-help.mouse="`${t.tooltip}`"
    >
      <template v-if="t.type === 'SWITCH'">
        <button v-if="valueByKey(t.key) === true"
                class="asd-btn-confirm"
                @click="setKeyValue(t.key, false)"
        >
          <i class="fas"
             :class="[`${t.styleByValue.true.fas}`]"
          ></i>
        </button>
        <button v-if="valueByKey(t.key) === false"
                class="asd-btn-confirm"
                @click="setKeyValue(t.key, true)"
        >
          <i class="fas"
             :class="[`${t.styleByValue.false.fas}`]"
          ></i>
        </button>
      </template>
      <template v-if="t.type === 'ACTION'">
        <button class="asd-btn-confirm"
                @click="$emit(t.emit)"
        >
          <i class="fas"
             :class="[`${t.style.fas}`]"
          ></i>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { chain, get } from 'lodash'

export default {
    name: 'ToolPanel',
    props: {
        value: {
            required: true,
            type: Object,
        },
        config: {
            required: false,
            type: Array,
            default: _ => [],
        },
    },
    methods: {
        setKeyValue(key, value) {
            const object =
                 chain({})
                     .merge(this.value)
                     .set(key, value)
                     .value()
            this.$emit('input', object)
        },
        valueByKey(key) {
            return get(this.value, key)
        },
    },
}

</script>

<style scoped>
.toolbar-box {
    width: 100%;
    height: 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}
.toolbar-box > div {
    margin-right: 5px;
}
.btn {
    box-shadow: none;
}
</style>

